"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { trackCtaClick, trackEvent } from "@/app/providers/ObservabilityProvider";
import { appTargetOfUrl, useAppLink } from "@/lib/analytics/app-links";

/**
 * Article call-to-action button. A web-app `href` gets the attribution handoff after
 * hydration; on phones it opens the store instead (same rule as every app CTA).
 */
export function CtaButton({ href, children }: { href: string; children: ReactNode }) {
  const { href: url, target } = useAppLink("article", { webBase: href });
  const isExternal = /^https?:\/\//.test(url);

  return (
    <Link
      href={url}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      onClick={() => {
        trackEvent("ressources-article-cta", { href }, { criticalOnNav: true });
        if (appTargetOfUrl(url)) trackCtaClick("article", target);
      }}
      className="not-prose my-2 inline-flex items-center justify-center gap-2 rounded-full bg-blue-main px-7 py-3.5 text-base font-semibold text-white no-underline transition-all duration-200 hover:scale-105 hover:bg-[#4F46E5]"
    >
      {children}
    </Link>
  );
}
